import Flickity from 'flickity-as-nav-for';

class projectenSlider {
	constructor(config) {
		this.config = Object.assign({
			scope: '.projecten_slider'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {

		var flkty = new Flickity('.projecten-slider');
		var carouselStatus = document.querySelector('.counter');

		function updateStatus() {
			var slideNumber = flkty.selectedIndex + 1;
			carouselStatus.textContent = slideNumber + ' ' + '/' + ' ' + flkty.slides.length + ' ' + 'projecten';
		}
		updateStatus();
		console.log(1);
		flkty.on('select', updateStatus );
	}
}

export default new projectenSlider;